import { useState } from "react";
import { useToast } from "../../../shared/hooks";
import { clientService, IClientDocument } from "../../../shared/services/api/client/clientService";

export function useClientDocuments(clientId: string) {
	const [documents, setDocuments] = useState<IClientDocument[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const toastHandler = useToast();

	const fetchDocuments = async () => {
		setIsLoading(true);
		try {
			const result = await clientService.getAllByClientId(clientId);
			if (result instanceof Error) throw result;

			setDocuments(result);
		} catch (error: any) {
			toastHandler.present({
				type: "error",
				messageOrContent: error?.message || "Erro ao carregar documentos do cliente",
				position: "top-right",
			});
		} finally {
			setIsLoading(false);
		}
	};

	return { documents, isLoading, fetchDocuments };
}
